export default __webpack_public_path__ + "static/slogan-79748f5f5a926ed6b46620a8210142c5.svg";